import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=e6e27016&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"
import style0 from "./transfer.vue?vue&type=style&index=0&id=e6e27016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e27016",
  null
  
)

export default component.exports